import { createContext, useContext, useMemo, useState } from "react";

const ReturnExchangeDownloadFormsValueContext = createContext();
const ReturnExchangeDownloadFormsActionsContext = createContext();

export function ReturnExchangeDownloadFormsContextProvider({ children }) {
    const [returnExchangeDownloadForms, setReturnExchangeDownloadForms] = useState([]);

    const returnExchangeDownloadFormsActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setReturnExchangeDownloadForms(newValues);
                },
                setValue: setReturnExchangeDownloadForms
            }
        },
        []
    )

    return (
        <>
            <ReturnExchangeDownloadFormsActionsContext.Provider value={{ returnExchangeDownloadForms: returnExchangeDownloadFormsActions }}>
                <ReturnExchangeDownloadFormsValueContext.Provider value={{ returnExchangeDownloadForms }}>
                    {children}
                </ReturnExchangeDownloadFormsValueContext.Provider>
            </ReturnExchangeDownloadFormsActionsContext.Provider>
        </>
    );
}

export function useReturnExchangeDownloadFormsValueContextHook(props) {
    const value = useContext(ReturnExchangeDownloadFormsValueContext);

    if (value === undefined) {
        throw new Error('useReturnExchangeDownloadFormsValueContextHook should be used within ReturnExchangeDownloadFormsValueContext');
    }

    return {
        returnExchangeDownloadForms: value.returnExchangeDownloadForms,
    };
}

export function useReturnExchangeDownloadFormsActionsContextHook(props) {
    const value = useContext(ReturnExchangeDownloadFormsActionsContext);

    if (value === undefined) {
        throw new Error('useReturnExchangeDownloadFormsActionsContextHook should be used within ReturnExchangeDownloadFormsActionsContext');
    }

    return {
        returnExchangeDownloadForms: {
            onSet: value.returnExchangeDownloadForms.onSet,
            setValue: value.returnExchangeDownloadForms.setValue
        },
    };
}